import { useConfig } from '../../config';
import { CategoryTreeContainer } from '../../state/categories';
import { ButtonLink } from '../Form/Button';
import './SubcategoryLinks.css';

type SubcategoryLinksProps = { perma: string };

export const SubcategoryLinks = ({ perma }: SubcategoryLinksProps) => {
	const { getSubcategories, getBreadcrumbs } = CategoryTreeContainer.useContainer();
	const { locale } = useConfig();
	const items = [...(getSubcategories(perma) ?? [])].sort((a, b) =>
		a.name.localeCompare(b.name, locale, { sensitivity: 'base' })
	);
	const breadcrumbs = getBreadcrumbs(perma) ?? [];
	const currentBreadcrumb = breadcrumbs.at(-1);
	const hasSubcategories = items.length > 0;
	const highlightedSubcategory =
		hasSubcategories && currentBreadcrumb ? (
			<ButtonLink
				className="secondary current-category"
				key={currentBreadcrumb.id}
				linkTo={'/' + currentBreadcrumb.perma}
			>
				{currentBreadcrumb.name}
			</ButtonLink>
		) : null;

	return (
		<subcategory-links>
			{highlightedSubcategory}
			{items.map((e) => (
				<ButtonLink className="secondary" key={e.id} linkTo={'/' + e.perma}>
					{e.name}
				</ButtonLink>
			))}
		</subcategory-links>
	);
};
